import logo from "../../assets/images/logo/logo.svg";
import styles from "../../styles/components/common/Logo.module.css";

const Logo = () => {
  return (
    <div className={styles.navLogo}>
      <img src={logo} alt="Simpary Logo" />
    </div>
  );
};

export default Logo;
